/* KUTEE' PDP gallery — thumbnail switcher (desktop) + zoom lightbox.
   Clicking a [data-ku-thumb] shows the matching [data-ku-frame] and hides the
   rest (CSS shows only .is-active at >=990px). Mobile keeps the swipe
   carousel; the thumbs row is display:none there so this JS is inert.
   The [data-ku-zoom-open] button (and clicking a frame image) opens the
   active frame's data-ku-zoom-src (2048px master) in a full-screen lightbox.
   Re-inits safely on Theme Editor section reloads via a per-element flag. */
(() => {
  const openLightbox = (gallery, frame) => {
    const active =
      frame ||
      gallery.querySelector('[data-ku-frame].is-active') ||
      gallery.querySelector('[data-ku-frame]');
    if (!active) return;
    const src = active.getAttribute('data-ku-zoom-src');
    if (!src) return;

    const previousFocus = document.activeElement;
    const lightbox = document.createElement('div');
    lightbox.className = 'ku-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');

    const img = document.createElement('img');
    img.src = src;
    img.alt = active.querySelector('img') ? active.querySelector('img').alt : '';

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'ku-lightbox__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = '×';

    const close = () => {
      lightbox.remove();
      document.removeEventListener('keydown', onKey);
      document.documentElement.style.overflow = '';
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    };
    const onKey = (event) => {
      if (event.key === 'Escape') close();
    };

    closeBtn.addEventListener('click', close);
    lightbox.addEventListener('click', (event) => {
      if (event.target !== img) close();
    });
    document.addEventListener('keydown', onKey);

    lightbox.append(img, closeBtn);
    document.body.append(lightbox);
    document.documentElement.style.overflow = 'hidden';
    closeBtn.focus();
  };

  const init = () => {
    document.querySelectorAll('[data-ku-gallery]').forEach((gallery) => {
      if (gallery.__kuGalleryInit) return;
      gallery.__kuGalleryInit = true;

      const zoomBtn = gallery.querySelector('[data-ku-zoom-open]');
      if (zoomBtn) zoomBtn.addEventListener('click', () => openLightbox(gallery));
      gallery.querySelectorAll('[data-ku-frame]').forEach((frame) => {
        frame.addEventListener('click', () => openLightbox(gallery, frame));
      });

      const frames = gallery.querySelectorAll('[data-ku-frame]');
      const thumbs = gallery.querySelectorAll('[data-ku-thumb]');
      if (frames.length < 2 || !thumbs.length) return;

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = thumb.getAttribute('data-ku-thumb');

          frames.forEach((frame) => {
            frame.classList.toggle('is-active', frame.getAttribute('data-ku-frame') === index);
          });

          thumbs.forEach((t) => {
            const isActive = t === thumb;
            t.classList.toggle('is-active', isActive);
            if (isActive) {
              t.setAttribute('aria-current', 'true');
            } else {
              t.removeAttribute('aria-current');
            }
          });
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
